
import _ from 'lodash';
import moment from 'moment';

export const DEVELOPMENT_MODE = process.env.NODE_ENV !== 'production';

export const APP_ID_USERPORTAL = 'userportal';
export const APP_ID_BACKOFFICE = 'backoffice';
export const APP_ID_ADMIN = 'admin';

export const DAYS_IN_MONTH = 21.7;
export const VAT_RATE = 21;
export const VAT_MULTIPLICATOR = 1.21;

export const COMPANY_ACCOUNT_BANK = 'Raiffeisenbank';
export const COMPANY_ACCOUNT_NUMBER = '5547520002/5500';
export const COMPANY_ACCOUNT_IBAN = 'CZ1855000000005547520002';
export const COMPANY_ACCOUNT_SWIFT = 'RZBCCZPP';

export const PAYMENT = {
  BANK: 'bank'
};

export const ADMIN_COMPANY_SLUG = 'skilleto-network-sro';
export const ADMIN_COMPANY_ID = 'acf9b45b-5c6f-4c27-ac46-29fc7d18a371';
export const SERVICE_USER_ID = '45f45e06-b946-44cb-8da9-d853d4bb82f0';

export const APP_IDS = [APP_ID_USERPORTAL, APP_ID_BACKOFFICE, APP_ID_ADMIN];
export const INVITATION_APP_IDS = [APP_ID_USERPORTAL, APP_ID_BACKOFFICE];

export const GA_USERPORTAL = process.env.NODE_ENV === 'production' ? 'G-9XTYHB2YH1' : 'G-64V5TK694L';
export const GA_BACKOFFICE = 'G-STTE5NBHGX';

export const HTTP_UNAUTHORIZED_ERROR = 401;
export const HTTP_BAD_REQUEST_ERROR = 400;
export const HTTP_NOT_ALLOWED_ERROR = 403;
export const HTTP_NOT_FOUND_ERROR = 404;
export const HTTP_CONFLICT_ERROR = 409;
export const HTTP_REQUEST_ABORTED = 499;

export const DATE_FORMAT_CZ = 'DD.MM.YYYY';
export const DATETIME_FORMAT_CZ = 'DD.MM.YYYY HH:mm';
export const DATETIME_FORMAT_FULL_CZ = 'DD.MM.YYYY HH:mm:ss';
export const DATE_FORMAT_EN = 'MM/DD/YYYY';
export const DATETIME_FORMAT_EN = 'MM/DD/YYYY h:mm A';
export const DATETIME_FORMAT_FULL_EN = 'MM/DD/YYYY h:mm:ss A';
export const DATEPICKER_DATE_FORMAT_CZ = 'dd.MM.yyyy';
export const DATEPICKER_DATE_FORMAT_EN = 'MM/dd/yyyy';

export const PRE_REGISTERED_USER_PASSWORD_HASH = 'PRE_REGISTERED_USER_PASSWORD_HASH';

export const APPLY_FORM_MIN_SCORE_WARNING = 30;
export const SALARY_RANGE_MAX_DIFF = 150;

export const ATTACHMENT_MAX_SIZE_MB = 5;
export const ATTACHMENT_MAX_SIZE = ATTACHMENT_MAX_SIZE_MB * 1024 * 1024;

export const ATTACHMENT_TYPE = {
  CV: 'cv',
  COVER: 'cover',
  OTHER: 'other'
};
export const ATTACHMENT_TYPES = _.values(ATTACHMENT_TYPE);

export const LINK_TYPE = {
  LINKEDIN: 'linkedin',
  GITHUB: 'github',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  WEB: 'web',
  BLOG: 'blog',
  PORTFOLIO: 'portfolio',
  REFERENCE: 'reference',
  OTHER: 'other'
};

export const LINK_TYPES = _.values(LINK_TYPE);

export const LINKEDIN_URL_PREFIX = 'https://www.linkedin.com/in/';
export const LINKEDIN_URL_MASK = /linkedin.com\/in\/([^/?]+)/;

export const COMPANY_LOGO_POSITION = {
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  CENTER: 'center',
  UNDER: 'under',
  HIDE: 'hide',
};

export const COMPANY_LOGO_POSITIONS = _.values(COMPANY_LOGO_POSITION);

export const COMPANY_IMAGE_MIN_HEIGHT = 200;

export const COMPANY_IMAGE_MAX_HEIGHT = 600;

export const CONTENT_MODULE_TYPE = {
  TEXT: 'text',
  PEOPLE: 'people',
  GALLERY: 'gallery',
  HTML: 'html'
};

export const CONTENT_MODULE_TYPES = _.values(CONTENT_MODULE_TYPE);

export const PEOPLE_MODULE_PHOTO_STYLE = {
  SQUARE: 'square',
  CIRCLE: 'circle',
};

export const PEOPLE_MODULE_PHOTO_STYLES = _.values(PEOPLE_MODULE_PHOTO_STYLE);

export const PEOPLE_MODULE_DISPLAY = {
  MATRIX: 'matrix',
  SLIDER: 'slider',
  LIST: 'list',
};

export const PEOPLE_MODULE_DISPLAYS = _.values(PEOPLE_MODULE_DISPLAY);

export const PEOPLE_MODULE_CONTACT = {
  LINKEDIN: 'linkedin',
  GITHUB: 'github',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  WEB: 'web',
  PHONE: 'phone',
  MAIL: 'mail',
};

export const PEOPLE_MODULE_CONTACTS = _.values(PEOPLE_MODULE_CONTACT);

export const GALLERY_MODULE_DISPLAY = {
  ROWS: 'rows',
  COLUMNS: 'columns',
  MASONRY: 'masonry',
};

export const GALLERY_MODULE_DISPLAYS = _.values(GALLERY_MODULE_DISPLAY);

export const OAUTH = {
  LINKEDIN: {
    PROVIDER: 'linkedin',
    CLIENT_ID: '77w9rkgb5dm4ai',
    STATE_KEY: 'LinkedInState'
  },
  GOOGLE: {
    PROVIDER: 'google',
    CLIENT_ID: '673224305999-omh1fe0rg0a1rafsivveejvc2ooscfvq.apps.googleusercontent.com',
    STATE_KEY: 'GoogleState'
  }
};

// translated
export const LEVELS = {
  1: 'beginner',
  2: 'intermediate',
  3: 'expert'
};

export const DEFAULT_LANGUAGE_ID = 1;
export const DEFAULT_LANGUAGE_CODE = 'cs';
export const DEFAULT_DATA_LANGUAGE_CODE = 'cs';

export const LANGUAGE = {
  CS: DEFAULT_LANGUAGE_CODE,
  EN: 'en',
  SK: 'sk',
  DE: 'de'
};

export const LANGUAGE_NAME = {
  [LANGUAGE.CS]: 'Czech',
  [LANGUAGE.SK]: 'Slovak',
  [LANGUAGE.EN]: 'English',
  [LANGUAGE.DE]: 'German',
};

export const LANGUAGES = [LANGUAGE.CS, LANGUAGE.SK, LANGUAGE.EN, LANGUAGE.DE];

export const I18N_LANGUAGES = [LANGUAGE.CS, LANGUAGE.SK, LANGUAGE.EN];

export const DATA_LANGUAGES = [LANGUAGE.CS, LANGUAGE.SK, LANGUAGE.EN];

// translated
export const LANGUAGE_LEVELS = {
  1: 'A1',
  2: 'A2',
  3: 'B1',
  4: 'B2',
  5: 'C1',
  6: 'C2'
};

// translated
export const EDUCATION = {
  TRAINING_COURSE: 'X',
  BASIC: '2A-ZS',
  VOCATIONAL: '3C-OU',
  VOCATIONAL_GRADUATION: '3A-SOU',
  SECONDARY_SCHOOL: '3A-SS',
  LANGUAGE_SCHOOL: '4A',
  HIGHER_SCHOOL: '5B-VOS',
  UNIVERSITY: '5A',
  POSTGRADUATE: '6',
};
export const EDUCATIONS = _.values(EDUCATION);
export const EDUCATIONS_ISCED_SORTED = ['2A', '3C', '3A', '4A', '5B', '5A', '6'];

export const EDUCATION_TITLE = {
  X: 'training, course',
  '2A-ZS': 'elementary school',
  '3C-OU': 'vocational school without graduation',
  '3A-SOU': 'vocational school with graduation',
  '3A-SS': 'secondary school with graduation',
  '4A': 'language school (post-secondary)',
  '5B-VOS': 'higher vocational school',
  '5A': 'university',
  6: 'university - postgraduate'
};

export const EDU_LEVELS_IMPORT_MAP = {
  1: '2A-ZS',
  '2A': '2A-ZS',
  '3C': '3C-OU',
  '3A': '3A-SS',
  '4A': '4A',
  '5B': '5B-VOS',
  '5A': '5A',
  6: '6'
};

export const getImportedEduLevel = (inputLevel = '') => {
  if (!EDU_LEVELS_IMPORT_MAP[inputLevel]) return null;

  return EDU_LEVELS_IMPORT_MAP[inputLevel];
};

export const PART_TIME_EMPLOYMENT = 'parttime-employment';
export const PART_TIME_CONTRACT = 'parttime-contract';

// translated
export const EMPLOYMENT = {
  FULLTIME_EMPLOYMENT: 'fulltime-employment',
  PART_TIME_EMPLOYMENT,
  FULLTIME_CONTRACT: 'fulltime-contract',
  PART_TIME_CONTRACT,
  ORDER_ONETIME: 'order-onetine',
  CONSULTANCY: 'consultancy',
  INTERN: 'intern',
};
export const EMPLOYMENTS = _.values(EMPLOYMENT);
export const RATE_VALIDATED_EMPLOYMENTS = [
  EMPLOYMENT.FULLTIME_EMPLOYMENT,
  EMPLOYMENT.FULLTIME_CONTRACT,
  EMPLOYMENT.PART_TIME_EMPLOYMENT,
  EMPLOYMENT.PART_TIME_CONTRACT,
];

export const RATE_TYPE = {
  UNPAID: 'unpaid',
  FIXED: 'fixed',
  RANGE: 'range'
};

// translated
export const DEFAULT_RATE_PERIOD = 3;
export const RATE_PERIOD = {
  HOURLY: 1,
  DAILY: 2,
  MONTHLY: DEFAULT_RATE_PERIOD,
  YEARLY: 4,
  PIECE: 5
};

export const HOURLY_RATE_MIN = 150;
export const HOURLY_RATE_MAX = 3000;
export const DAILY_RATE_MIN = 1200;
export const DAILY_RATE_MAX = 25000;
export const MONTHLY_RATE_MIN = 25000;
export const MONTHLY_RATE_MAX = 500000;
export const YEARLY_RATE_MIN = 300000; // 25.000 monthly
export const YEARLY_RATE_MAX = 6000000; // 500.000 monthly

// translated
export const DEFAULT_ALLOCATION_PERIOD = 3;
export const ALLOCATION_PERIOD = {
  DAYS: 1,
  WEEKS: 2,
  MONTHS: DEFAULT_ALLOCATION_PERIOD,
  YEARS: 4
};

export const HOMEOFFICE_MIN_VALUE = 0;
export const HOMEOFFICE_MAX_VALUE = 5;

export const REMOTE_WORK = {
  NO: 'no',
  YES: 'yes',
  ONLY: 'only'
};

// translated, used currency codes only
export const DEFAULT_CURRENCY = 'CZK';

export const CURRENCY = {
  CZK: 'CZK',
  EUR: 'EUR',
  USD: 'USD',
};

export const CURRENCIES = [CURRENCY.CZK, CURRENCY.EUR, CURRENCY.USD];

export const ORDER_CURRENCIES = [CURRENCY.CZK, CURRENCY.EUR];

// TODO: move to lib
export const getSliderStepByCurrency = currency => {
  switch (currency) {
    case CURRENCY.CZK:
      return 1000;

    case CURRENCY.EUR:
    case CURRENCY.USD:
      return 10;

    default:
      return 1;
  }
};

export const getSliderMinByCurrency = (realMin, currency) => {
  if (realMin <= 0) {
    return 0;
  }

  const step = getSliderStepByCurrency(currency);
  return Math.floor(realMin / step) * step;
};

export const getSliderMaxByCurrency = (realMax, currency) => {
  if (realMax <= 0) {
    return 0;
  }

  const step = getSliderStepByCurrency(currency);
  return Math.ceil(realMax / step) * step;
};

export const ANONYMIZATION = {
  NONE: 0,
  PARTIAL: 1,
  FULL: 2
};

// translated
export const JOB_APPLICATION_STATUS = {
  INITIAL: 'sent',
  READ: 'read',
  REVIEW: 'in-review',
  INTERVIEW: 'inteview',
  DECISION: 'in-decision',
  OFFER: 'offer',
  HIRED: 'hired',
  CANCELED: 'user-cancel',
  REJECTED: 'company-reject'
};

export const JOB_APPLICATION_STATUSES_BACKOFFICE = [
  JOB_APPLICATION_STATUS.REVIEW,
  JOB_APPLICATION_STATUS.INTERVIEW,
  JOB_APPLICATION_STATUS.DECISION,
  JOB_APPLICATION_STATUS.OFFER,
  JOB_APPLICATION_STATUS.HIRED,
  JOB_APPLICATION_STATUS.REJECTED
];

const inactiveJaStatusIds = [
  JOB_APPLICATION_STATUS.CANCELED,
  JOB_APPLICATION_STATUS.REJECTED,
  JOB_APPLICATION_STATUS.HIRED
];
export const isJobApplicationInactive = statusId => inactiveJaStatusIds.includes(statusId);

export const JOB_APPLICATION_STATUS_NOTIFICATIONS = {
  [APP_ID_BACKOFFICE]: [
    JOB_APPLICATION_STATUS.CANCELED
  ],
  [APP_ID_USERPORTAL]: [
    // JOB_APPLICATION_STATUS.REJECTED,
    // JOB_APPLICATION_STATUS.HIRED,
    // JOB_APPLICATION_STATUS.CANCELED
  ],
};

export const JOB_APPLICATION_TYPE = {
  APPLICANT: 'applicant',
  CANDIDATE: 'candidate'
};

// job_application_ai_summary.status: the row is created with the application
// (pending) and finalized by the user-post-processor worker
export const JOB_APPLICATION_AI_SUMMARY_STATUS = {
  PENDING: 'pending',
  GENERATED: 'generated',
  LIMIT_EXHAUSTED: 'limit_exhausted',
  FAILED: 'failed'
};

// translated
export const JOB_OFFER_STATUS = {
  INITIAL: 'sent',
  READ: 'read',
  USER_ACCEPT: 'user-accept',
  USER_REJECT: 'user-reject',
  COMPANY_CANCEL: 'company-cancel'
};

export const inactiveJoStatusIds = [
  JOB_OFFER_STATUS.USER_REJECT,
  JOB_OFFER_STATUS.COMPANY_CANCEL,
  JOB_OFFER_STATUS.USER_ACCEPT
];
export const isJobOfferInactive = statusId => inactiveJoStatusIds.includes(statusId);

export const activeJoStatusIds = [JOB_OFFER_STATUS.INITIAL, JOB_OFFER_STATUS.READ];
export const isJobOfferCancelable = statusId => activeJoStatusIds.includes(statusId);

export const DAYS = [];
for (let i = 1; i <= 31; i++) {
  DAYS.push({ value: i, label: i });
}

// translated
export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

export const YEARS = [];
const currentYear = new Date().getFullYear();
for (let y = currentYear; y > currentYear - 80; y--) {
  YEARS.push({ value: y, label: y });
}

export const NOT_SPECIFIED_SLUG = 'not-specified';

// translated
export const COMPANY_SIZE = {
  STARTUP: 'startup',
  MICRO: 'micro',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export const COMPANY_SIZES = _.values(COMPANY_SIZE);

export const COMPANY_DESCRIPTION_MAX_LENGTH = 255;

export const COMPANY_TYPE = {
  EMPLOYER: 'employer',
  AGENCY: 'agency'
};

export const SUITABLE_FOR = {
  STUDENTS: 'students',
  GRADUATES: 'graduates',
  TRAINEE: 'trainees',
  JUNIOR: 'juniors',
  MEDIOR: 'mediors',
  SENIOR: 'seniors'
};

export const SEO_TYPES = ['company', 'field', 'role', 'skill', 'city', 'suitableFor'];

// benefit titles come localized from the API (benefit_intl), they are not in the locales
export const TRANSLATED_TYPES = [
  'field', 'role', 'employment', 'companySize', 'companyType',
  'remoteWork', 'suitableFor'
];

export const getTranslatedTypePath = (type, slug) => slug === NOT_SPECIFIED_SLUG
  ? 'common:notSpecified'
  : `common:${type}.${slug}`;

export const MATCH = {
  NONE: 'none',
  LOW: 'low',
  PARTIAL: 'partial',
  FULL: 'full',
};

export const SUBSCRIPTION_WARNING_DAYS_FROM = 7;
export const SUBSCRIPTION_WARNING_DAYS = [7, 2]; // warn 7 and 2 days before expiration
export const SUBSCRIPTION_EXTRA_DAYS = 7;
export const SUBSCRIPTION_PLAN_ID_FREE = 6;
export const SUBSCRIPTION_PLAN_ID_TRIAL = 1;
export const SUBSCRIPTION_PLAN_ID_STANDARD_LEAD = 2;
export const SUBSCRIPTION_PLAN_ID_STANDARD_FIX = 5;
export const SUBSCRIPTION_PLAN_ID_HIRE = 9;
// plans 14 and 16 display names: Start / Max
export const SUBSCRIPTION_PLAN_ID_RECRUITMENT = 14;
export const SUBSCRIPTION_PLAN_ID_PREMIUM = 16;

export const SUBSCRIPTION_LENGTH_BETA_MONTHS = 3;
export const SUBSCRIPTION_LENGTH_TRIAL_MONTHS = 1;

export const isLeadPlan = (planId) => ~~planId === SUBSCRIPTION_PLAN_ID_STANDARD_LEAD;
export const isHirePlan = (planId) => ~~planId === SUBSCRIPTION_PLAN_ID_HIRE;

export const SUBSCRIPTION_ORDER_STATUS = {
  NEW: 1,
  CANCELED: 2,
  COMPLETED: 3,
};

export const SUBSCRIPTION_ORDER_BILLING_PERIOD = {
  ONE_TIME: 'one-time',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  SEMI_ANUALLY: 'semi-annually',
  ANUALLY: 'annually'
};

export const SUBSCRIPTION_DEFAULT_LEAD_PRICE = {
  [SUBSCRIPTION_PLAN_ID_STANDARD_LEAD]: {
    CZK: 149,
    EUR: 6,
    USD: 7,
  }
};

export const LEAD_TYPE = {
  VALID: 'valid',
  RECURRING: 'recurring',
  CANCELED: 'canceled',
  REVIEW: 'review',
};

export const LEAD_REVIEW_REASONS = [
  'invalidContact',
  'scam',
  'b2b',
  'activeContact',
];

export const LEAD_QUALITY = {
  NONE: 'none',
  BASIC: 'basic',
  MATCH: 'match',
  QUALIFIED: 'qualified',
  HIT: 'hit',
};

export const LEAD_QUALITY_OPTIONS = [
  LEAD_QUALITY.BASIC,
  LEAD_QUALITY.MATCH,
  LEAD_QUALITY.QUALIFIED,
  LEAD_QUALITY.HIT,
];

export const LEAD_QUALITY_SETUP = {
  [LEAD_QUALITY.NONE]: {
    multiplier: 1,
    minScore: 0,
    mustMeetSkills: false,
    mustMeetExperience: false,
    mustMeetEducation: false,
    mustMeetLocality: false,
  },
  [LEAD_QUALITY.BASIC]: {
    multiplier: 1,
    minScore: 40,
    mustMeetSkills: false,
    mustMeetExperience: false,
    mustMeetEducation: false,
    mustMeetLocality: false,
  },
  [LEAD_QUALITY.MATCH]: {
    multiplier: 2.008,
    minScore: 60,
    mustMeetSkills: true,
    mustMeetExperience: false,
    mustMeetEducation: false,
    mustMeetLocality: true,
  },
  [LEAD_QUALITY.QUALIFIED]: {
    multiplier: 3.013,
    minScore: 75,
    mustMeetSkills: true,
    mustMeetExperience: true,
    mustMeetEducation: true,
    mustMeetLocality: true,
  },
  [LEAD_QUALITY.HIT]: {
    multiplier: 4.02,
    minScore: 90,
    mustMeetSkills: true,
    mustMeetExperience: true,
    mustMeetEducation: true,
    mustMeetLocality: true,
  },
};

export const B2B_LEVEL = {
  DISABLED: 0,
  ENABLED: 1,
  ONLY: 2
};

// All numeric limits share one semantics: 0 (or missing) = feature disabled,
// -1 = unlimited, > 0 = the limit. The three candidate quotas count over a sliding
// 30-day window, jobsLimit (cumulative) and activeJobsLimit (concurrent) do not.
export const SUBSCRIPTION_PLAN_FEATURES = {
  CANDIDATES_ACCESS: 'candidates',
  B2B_ACCESS: 'btob',
  // > 0 = distinct candidates contacted (job offer sent) per sliding 30 days
  CONTACTED_CANDIDATES_LIMIT: 'contactedCandidatesLimit',
  JOBS_LIMIT: 'jobsLimit',
  ACTIVE_JOBS_LIMIT: 'activeJobsLimit',
  NO_ANONYMIZATION: 'noAnonymization',
  FILTER_CV: 'filterCv',
  HTML_MODULE: 'htmlModule',
  SCORE_DIMENSIONS: 'scoreDimensions',
  // > 0 = AI summaries generated per sliding 30 days
  APPLICATION_AI_SUMMARIES_LIMIT: 'applicationAiSummariesLimit',
  LEAD_RESTRICTIONS: 'leadRestrictions',
  // 0 = imported candidates not available at all (no import, no search filter),
  // > 0 = CVs imported per sliding 30 days
  IMPORTED_CANDIDATES_LIMIT: 'importedCandidatesLimit',
  // boolean: follow-up questions to an applicant (AI-drafted from the AI summary's
  // "to verify" points, edited and sent by the recruiter); false only on the Free plan
  APPLICANT_FOLLOW_UP: 'applicantFollowUp',
  // boolean: AI-drafted rejection message to an applicant (the recruiter edits and sends
  // it as a regular status change with a message); false only on the Free plan. The
  // rejection action itself and a hand-written message are available on every plan.
  APPLICANT_REJECTION_MESSAGE: 'applicantRejectionMessage',
  // boolean: AI-drafted message offering a position to a candidate (the recruiter edits
  // and sends it as the regular job offer); false only on the Free plan. The offer itself
  // and a hand-written message are available wherever CANDIDATES_ACCESS is.
  CANDIDATE_OFFER_MESSAGE: 'candidateOfferMessage'
};

// follow-up questions to an applicant (job_application_follow_up), shared by the
// FE editors and the API validation
export const FOLLOW_UP_LIMITS = {
  MAX_QUESTIONS: 5,
  QUESTION_MAX_LENGTH: 500,
  ANSWER_MAX_LENGTH: 1000
};

// how the rejection message is prepared: AI from the application data, AI from the data
// and the recruiter's notes, or written by the recruiter (custom = frontend only, the
// generate endpoint takes ai / ai_notes)
export const JOB_APPLICATION_REJECTION_MODE = {
  AI: 'ai',
  AI_NOTES: 'ai_notes',
  CUSTOM: 'custom'
};
export const REJECTION_NOTES_MAX_LENGTH = 5000;

// how the message offering a position to a candidate is prepared: AI from the candidate's
// and the position's data, AI from the data and the recruiter's notes, or written by the
// recruiter (custom = frontend only, the generate endpoint takes ai / ai_notes)
export const CANDIDATE_OFFER_MESSAGE_MODE = {
  AI: 'ai',
  AI_NOTES: 'ai_notes',
  CUSTOM: 'custom'
};
export const OFFER_NOTES_MAX_LENGTH = 5000;

// typed placeholder rows in job_application_change (message and status NULL): the
// follow-up questions sent by the recruiter and the answers sent by the applicant
// appear in the application history and count as unread like a message
export const JOB_APPLICATION_CHANGE_TYPE = {
  FOLLOW_UP_QUESTIONS: 'follow_up_questions',
  FOLLOW_UP_ANSWERS: 'follow_up_answers'
};

export const OUTREACH_CHANNEL = {
  JOB_OFFER: 'job_offer',
  // automatic offer sent by the AI recruiter in Skilleto's name; job_offer.channel carries
  // it too, and it never counts against contactedCandidatesLimit
  AI_RECRUITER: 'ai_recruiter'
};

// typed rows in job_offer_change: the automatic assistant's reply to the user's message
// in an AI recruiter offer
export const JOB_OFFER_CHANGE_TYPE = {
  AI_REPLY: 'ai_reply'
};

// AI recruiter: Skilleto finds users matching the positions of a client with an activation
// and sends them personalized offers (docs/ai-recruiter/technicke-zadani.md)
export const AI_RECRUITER = {
  DEFAULT_MIN_SCORE: 90,
  // the admin form's default maximum age of a job (months since its creation), empty = no limit
  DEFAULT_MAX_JOB_AGE_MONTHS: 6,
  // one offer of the same position to the same user per this many months, also the window
  // in which an offer and the new-job notification never both reach a user about one position
  JOB_REOFFER_MONTHS: 6,
  // at most one offer per user per this many days, whichever client
  USER_OFFER_DAYS: 7,
  // an open application at the client blocks an offer only when created within this many
  // months: many clients never close applications, those from an ATS integration never
  OPEN_APPLICATION_MONTHS: 3,
  MAX_PER_JOB_RUN: 20,
  MAX_PER_RUN: 100,
  SUBJECT_MAX: 100,
  PREHEADER_MAX: 100,
  // assistant replies per offer thread, then it stays silent
  MAX_REPLIES: 5,
  // how often the users whose profile changed are matched against the live positions
  USER_PASS_MINUTES: 60,
  // the pass ends this many minutes in the past, so that a profile saved just now has its
  // new embeddings in ES before it is scored (they are generated asynchronously)
  USER_PASS_DELAY_MINUTES: 10
};

export const AI_RECRUITER_TRIGGER = {
  PUBLISHED: 'published',
  USER_UPDATED: 'user_updated',
  ACTIVATION: 'activation'
};

export const AI_RECRUITER_ITEM_STATUS = {
  SELECTED: 'selected',
  SENT: 'sent',
  TEST: 'test',
  SKIPPED: 'skipped',
  FAILED: 'failed'
};

// why an ai_recruiter_item was skipped or failed
export const AI_RECRUITER_REASON = {
  ALREADY_OFFERED: 'already_offered',
  NOTIFIED: 'notified', // rule dropped 2026-11-03, only older items carry it
  WEEKLY_LIMIT: 'weekly_limit',
  BETTER_MATCH: 'better_match',
  CAP: 'cap',
  APPLIED: 'applied',
  OPEN_OFFER: 'open_offer',
  OPEN_APPLICATION: 'open_application',
  MAIL_DISABLED: 'mail_disabled',
  SUBJECT_INVALID: 'subject_invalid',
  EMPTY_TEXT: 'empty_text',
  INJECTION: 'injection',
  ERROR: 'error'
};

// how much of the user's message the assistant could answer from the ad and the portal facts
export const AI_RECRUITER_ANSWERED = {
  FULL: 'full',
  PARTIAL: 'partial',
  NONE: 'none'
};

// a run of one activation started from admin ("run now")
export const AI_RECRUITER_RUN_STATUS = {
  RUNNING: 'running',
  FINISHED: 'finished',
  FAILED: 'failed'
};

// current versions of the legal documents the company admin consents to on signup
export const TOS_VERSION = '3.0';
export const GDPR_VERSION = '3.0';

// why the client consent (terms_consent row) was recorded:
// SIGNUP = on finishing the company registration, ORDER = on placing a plan
// order (which also accepts the data-processing agreement - the ToS annex)
export const TERMS_CONSENT_REASON = {
  SIGNUP: 'signup',
  ORDER: 'order'
};

// current versions of the legal documents the portal user consents to on signup;
// versioned separately from the client documents above
export const PORTAL_TOS_VERSION = '3.0';
export const PORTAL_GDPR_VERSION = '3.0';

// SIGNUP = on finishing the portal registration (invitation / oauth),
// JOB_APPLICATION = on submitting a job application (logged-in or anonymous)
export const USER_TERMS_CONSENT_REASON = {
  SIGNUP: 'signup',
  JOB_APPLICATION: 'job_application'
};

const today = moment().startOf('day').unix();
const warnFrom = moment().startOf('day').add(SUBSCRIPTION_WARNING_DAYS_FROM, 'days').unix();

export const subscriptionWillExpireSoon = (validTo) => {
  const validToDate = moment(validTo).startOf('day').unix();
  return warnFrom >= validToDate && today <= validToDate;
};

export const LOOKING_FOR_JOB = {
  NO: 0,
  MAYBE: 1,
  YES: 2
};

export const CANDIDATE_TYPE = {
  USER: 'user',
  B2B: 'b2b'
};

export const CANDIDATE_TYPES = _.values(CANDIDATE_TYPE);

export const CANDIDATES_MIN_SCORE_DEFAULT = 50;
export const CANDIDATES_MIN_SCORE = 30;
export const NEW_JOB_NOTIFICATION_MIN_SCORE = 60;
export const CANDIDATE_SEARCH_MIN_SCORE = 60;
export const CANDIDATE_SEARCH_MIN_SKILLS = 2;

export const JOB_REACTIVATED_AS_NEW_DAYS = 7;

export const EXCLUSIVE_SEARCH_ITEM_KEYS = ['rate', 'companyType', 'homeoffice'];
export const SEARCH_MODE_SCORING = 'scoring';
export const SEARCH_MODE_STRICT = 'strict';

export const PLACES_API_PLACE_TYPE = {
  COUNTRY: 'country',
  LOCALITY: 'locality',
  AREA_LEVEL_1: 'administrative_area_level_1'
};

export const PLACES_API_COUNTRY_ID = {
  CZ: 'ChIJQ4Ld14-UC0cRb1jb03UcZvg',
};

export const JOB_MIN_SKILLS_COUNT = 3;
export const JOB_MIN_SKILLS_COUNT_MANAGED = 2;
export const getJobMinSkillsCount = (company) => (company && company.managed ? JOB_MIN_SKILLS_COUNT_MANAGED : JOB_MIN_SKILLS_COUNT);
export const JOB_MIN_HARD_SKILLS_COUNT = 1;
export const SUGGESTED_SKILLS_COUNT = 30;

export const MAIL = {
  JOB_PUBLISHED_NEW: 'job_published_new',
  JOB_PREPARED_NEW: 'job_prepared_new',
  JOB_MAX_LEAD_COSTS_EXCEEDED: 'job_max_lead_costs_exceeded',

  JOB_APPLICATION_CREATED: 'job_application_created',
  JOB_APPLICATION_RENOTIFICATION: 'job_application_renotification',
  JOB_APPLICATION_MESSAGE_ADDED: 'job_application_message_added',
  // follow-up questions: to the applicant when sent, to the job owners when answered
  // (both optional through the job_application_ prefix)
  JOB_APPLICATION_FOLLOW_UP_REQUESTED: 'job_application_follow_up_requested',
  JOB_APPLICATION_FOLLOW_UP_ANSWERED: 'job_application_follow_up_answered',
  JOB_APPLICATION_STATUS_REJECTED: `job_application_status_${JOB_APPLICATION_STATUS.REJECTED}`,
  JOB_APPLICATION_STATUS_HIRED: `job_application_status_${JOB_APPLICATION_STATUS.HIRED}`,
  JOB_APPLICATION_STATUS_CANCELED: `job_application_status_${JOB_APPLICATION_STATUS.CANCELED}`,

  INVITATION_CREATED: 'invitation_created',
  INVITATION_PRE_APPROVED_CREATED: 'invitation_pre_approved_created',
  INVITATION_NEW_USER_INVITED: 'invitation_new_user_invited',

  JOB_OFFER_CANCELED_BY_COMPANY: 'job_offer_canceled_by_company',
  JOB_OFFER_CREATED: 'job_offer_created',
  JOB_OFFER_RENOTIFICATION: 'job_offer_renotification',
  JOB_OFFER_REJECTED_BY_USER: 'job_offer_rejected_by_user',
  JOB_OFFER_MESSAGE_ADDED: 'job_offer_message_added',

  LEAD_OVERALL_COSTS: 'lead_overall_costs',
  LEAD_REVIEW_CREATED: 'lead_review_created',
  LEAD_REVIEW_ACCEPTED: 'lead_review_accepted',
  LEAD_REVIEW_REJECTED: 'lead_review_rejected',

  SUBSCRIPTION_NEW_ORDER: 'subscription_new_order',
  SUBSCRIPTION_ORDER_UPDATED: 'subscription_order_updated',
  SUBSCRIPTION_ORDER_CANCELED: 'subscription_order_canceled',
  SUBSCRIPTION_ORDER_COMPLETED: 'subscription_order_completed',
  SUBSCRIPTION_ACTIVATED: 'subscription_activated',
  SUBSCRIPTION_EXPIRED: 'subscription_expired',
  SUBSCRIPTION_SWITCHED: 'subscription_switched',
  SUBSCRIPTION_WILL_EXPIRE: 'subscription_will_expire',
  SUBSCRIPTION_WILL_EXPIRE_TODAY: 'subscription_will_expire_today',

  // Product Announcements and Updates
  PRODUCT_UPDATES: 'product_updates',
  // Marketing Information. Special offers and promotions.
  MARKETING_INFORMATION: 'marketing_information',
  // blog
  BLOG_NEWS: 'blog_news',

  NPS: 'nps',
  FEEDBACK_CREATED: 'feedback_created',
  CONTACT_FORM: 'contact_form',
  CONTACT_REQUEST: 'contact_request',
  RESET_PASSWORD: 'reset_password',
  NEW_SKILL_SUGGESTED: 'new_skill_suggested',
  NEW_BENEFIT_SUGGESTED: 'new_benefit_suggested',

  NEW_CANDIDATES_NEW_JOB: 'new_candidates_new_job',
  NEW_CANDIDATES_HOURLY: 'new_candidates_hourly',
  NEW_CANDIDATES_DAILY: 'new_candidates_daily',
  NEW_CANDIDATES_WEEKLY: 'new_candidates_weekly',
  NEW_CANDIDATES_MONTHLY: 'new_candidates_monthly',

  PROFILE_HINT_CREATE_PROFILE_USER: 'profile_hint_create_profile',
  USER_SIGNUP_WELCOME: 'user_signup_welcome',
  COMPANY_SIGNUP_WELCOME: 'company_signup_welcome',
  COMPANY_PF: 'marketing_information_company_pf',
  USER_PF: 'marketing_information_user_pf',

  // zrušení účtu (právo na výmaz) - transakční, nelze odhlásit
  ACCOUNT_DELETION_CONFIRM: 'account_deletion_confirm',
  ACCOUNT_DELETION_REQUESTED_INTERNAL: 'account_deletion_requested_internal',
  ACCOUNT_DELETION_COMPLETED_INTERNAL: 'account_deletion_completed_internal',
  ACCOUNT_DELETION_CLIENT_NOTICE: 'account_deletion_client_notice',

  // AI recruiter: the automatic offer (optional, ai_recruiter_ prefix) and the assistant's
  // reply to the user's own message in it (transactional, deliberately outside every prefix)
  AI_RECRUITER_OFFER_CREATED: 'ai_recruiter_offer_created',
  AI_OFFER_REPLY: 'ai_offer_reply'
};

export const USER_MAIL_PREFIX_KEY = {
  JOB_APPLICATION: 'job_application_',
  JOB_OFFER: 'job_offer_',
  // switches off the automatic offers only: offers sent by companies and the visibility in
  // candidate search stay
  AI_RECRUITER: 'ai_recruiter_',
};

export const USER_MAIL_PREFIX_KEYS = {
  [APP_ID_BACKOFFICE]: [
    USER_MAIL_PREFIX_KEY.JOB_APPLICATION,
    USER_MAIL_PREFIX_KEY.JOB_OFFER,
    MAIL.NEW_CANDIDATES_NEW_JOB,
    // MAIL.NEW_CANDIDATES_HOURLY,
    MAIL.NEW_CANDIDATES_DAILY,
    MAIL.NEW_CANDIDATES_WEEKLY,
    MAIL.NEW_CANDIDATES_MONTHLY,
    MAIL.LEAD_OVERALL_COSTS,
    'subscription_',
    MAIL.PRODUCT_UPDATES,
    MAIL.MARKETING_INFORMATION,
    MAIL.BLOG_NEWS,
  ],
  [APP_ID_USERPORTAL]: [
    USER_MAIL_PREFIX_KEY.JOB_APPLICATION,
    USER_MAIL_PREFIX_KEY.JOB_OFFER,
    USER_MAIL_PREFIX_KEY.AI_RECRUITER,
    'job_published_',
    'profile_hint_',
    MAIL.PRODUCT_UPDATES,
    MAIL.MARKETING_INFORMATION,
    MAIL.BLOG_NEWS
  ]
};

export const COMPANY_NOTIFICATIONS = [
  MAIL.LEAD_OVERALL_COSTS,
];

export const NEW_CANDIDATES_TYPE = {
  NEW_JOB: 1,
  HOURLY: 2,
  DAILY: 3,
  WEEKLY: 4,
  MONTHLY: 5
};

export const NEW_CANDIDATES_NOTIFICATION_TYPE = {
  [NEW_CANDIDATES_TYPE.NEW_JOB]: MAIL.NEW_CANDIDATES_NEW_JOB,
  [NEW_CANDIDATES_TYPE.HOURLY]: MAIL.NEW_CANDIDATES_HOURLY,
  [NEW_CANDIDATES_TYPE.DAILY]: MAIL.NEW_CANDIDATES_DAILY,
  [NEW_CANDIDATES_TYPE.WEEKLY]: MAIL.NEW_CANDIDATES_WEEKLY,
  [NEW_CANDIDATES_TYPE.MONTHLY]: MAIL.NEW_CANDIDATES_MONTHLY
};

export const isOptionalMail = (appId, mailKey) =>
  USER_MAIL_PREFIX_KEYS[appId]
  && USER_MAIL_PREFIX_KEYS[appId].some((prefix) => mailKey.indexOf(prefix) === 0);

export const ROLE = {
  FRONTEND_DEVELOPER: 1,
};

export const PROFILE_PARSER = {
  LINKEDIN: 'linkedin',
  CV: 'cv'
};

export const USER_IMPORT_SOURCE = {
  CV: 1,
  ATS: 2
};

export const USER_IMPORT_JOB_STATUS = {
  PENDING: 1,
  RUNNING: 2,
  FINISHED: 3,
  CANCELLED: 4
};

export const USER_IMPORT_ITEM_STATUS = {
  WAITING: 1,
  PROCESSING: 2,
  IMPORTED: 3,
  ERROR: 4,
  DUPLICATE: 5
};

export const USER_IMPORT_MAX_FILES = 50;

export const USER_IMPORT_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const USER_PROFILE_TYPE = {
  DEFAULT: 'default',
};

export const ALL_JOBS_KEY = 'allJobs';
export const ALL_JOBS_LINK = `/?${ALL_JOBS_KEY}`;

export const TOP_COMPANIES = [
  // '782195a0-543c-41bd-a3ea-338d2c7008ec', // seznam
  // 'b6a38106-381a-4a7d-8ddf-2bdf3b481d71', // skip pay
  // '88339001-403a-4aea-810a-525ee388b66c', // integra
  // '1238a0b0-a811-4acf-ab71-08c0594442ec', // inbrait
  // '8fabc847-37fe-4920-bb04-86017268ec97', // omio
  // '6b63cfd2-aa98-46a0-b864-f2502e1dc349', // iconity
  'b956a896-603e-4d7b-a8d1-ffdc5d8b504a', // mblue
  'b5d61299-a554-4bbb-b31e-3065d3a3c008', // grafton
  '7817855e-6d1c-4c96-9e1f-635cf63a87f3', // alza
  'a892bad6-c260-4889-9e7d-dfa39420d3f6', // apptime
  '18f2fc3d-971b-4abf-b0ea-ccaaca6bd7f4', // infa
  '2eb1069b-c495-44a7-8059-4c4210ca832a', // cleverlance
  'a28bc3f8-9421-4b70-a315-0ec02c2422fc', // first is
  '5f0d7a34-74df-47b8-8d7f-224dbd457420', // proxy iv
];

export const JOB_APPLICATION_EXPORT_COMPANY = {
  GRAFTON: 'b5d61299-a554-4bbb-b31e-3065d3a3c008',
  GI_GROUP: 'd6c42a44-7186-4b3e-9679-580cc7b68e61',
};

export const JOB_APPLICATION_EXPORT_AGREEMENT = {
  [JOB_APPLICATION_EXPORT_COMPANY.GRAFTON]: {
    LABEL_ID: 'common:applicationForm.agreement.grafton',
    LINK_ID: 'common:applicationForm.agreementLink.grafton',
    LINK_URL: {
      [LANGUAGE.CS]: 'https://www.grafton.cz/cs/ochrana-osobnich-udaju',
      [LANGUAGE.SK]: 'https://www.grafton.cz/cs/ochrana-osobnich-udaju',
      [LANGUAGE.EN]: 'https://www.grafton.cz/en/privacy-policy',
    }
  },
  [JOB_APPLICATION_EXPORT_COMPANY.GI_GROUP]: {
    LABEL_ID: 'common:applicationForm.agreement.giGroup',
    LINK_ID: 'common:applicationForm.agreementLink.giGroup',
    LINK_URL: {
      [LANGUAGE.CS]: 'https://cz.gigroup.com/zpracovani-osobnich-udaju/',
      [LANGUAGE.SK]: 'https://sk.gigroup.com/osobnych-udajov/',
      [LANGUAGE.EN]: 'https://uk.gigroup.com/privacy/',
    }
  },
};

export const JOB_APPLICATION_EXPORT_COMPANIES = _.values(JOB_APPLICATION_EXPORT_COMPANY);

export const ATS = {
  GRAFTON: 'grafton',
  RECRUITIS: 'recruitis',
  DATACRUIT: 'datacruit',
};

export const ATS_ALL = [
  { code: ATS.GRAFTON, name: 'Grafton', webhookUrl: null, private: true },
  {
    code: ATS.RECRUITIS,
    name: 'Recruitis',
    webhookUrl: 'https://www.skilleto.cz/webhook/recruitis/:companySlug',
    homepage: 'https://recruitis.io',
    help: {
      cs: 'https://blog.skilleto.cz/spoustime-integraci-s-ats-recruitis/',
      en: 'https://blog.skilleto.cz/en/spoustime-integraci-s-ats-recruitis/'
    },
    logo: '/images/recruitis.svg',
  },
  {
    code: ATS.DATACRUIT,
    name: 'Datacruit',
    webhookUrl: 'https://www.skilleto.cz/webhook/datacruit',
    homepage: 'https://www.datacruit.com',
    help: {
      cs: 'https://blog.skilleto.cz/spoustime-integraci-s-datacruit/',
      en: 'https://blog.skilleto.cz/en/spoustime-integraci-s-datacruit/'
    },
    logo: '/images/datacruit.svg',
  },
];

export const ATS_PUBLIC = ATS_ALL.filter((ats) => !ats.private);

export const JUNIOR_MONTHS_MAX = 18; // 1.5 roku
export const SENIOR_MONTHS_MIN = 60; // 5 let

export const getSkillLevelByExperience = (experience) => {
  const exp = Math.round(Number(experience) || 0);
  if (exp <= JUNIOR_MONTHS_MAX) return 1;
  if (exp >= SENIOR_MONTHS_MIN) return 3;
  return 2;
};

export const OLD_SLUG_REDIRECTION = [
  ['field/graphics-design', 'field/design-ux'],
  ['field/management', 'field/executive-management'],
  ['field/specialists-consultant', 'field/data-analytics-bi'],
  ['field/operations', 'field/it-operations-infrastructure'],
  ['field/marketing-advertising', 'field/marketing-communications'],
  ['role/ux-designer', 'role/ui-ux-designer'],
  ['role/ui-designer', 'role/ui-ux-designer'],
  ['role/ceo-coo', 'role/chief-executive-officer-ceo'],
  ['role/cto', 'role/chief-technology-officer-cto'],
  ['role/data-bi-dwh-bigdata', 'role/dwh-specialist'],
  ['role/it-administrator', 'role/is-it-administrator'],
  ['role/is-administrator', 'role/is-it-administrator'],
  ['role/analytic', 'role/it-analyst'],
];

export const containsOldSlug = pathname => OLD_SLUG_REDIRECTION.some(([oldSlug]) => pathname.includes(oldSlug));

export default {
  DEVELOPMENT_MODE,
  APP_ID_USERPORTAL,
  APP_ID_BACKOFFICE,
  APP_ID_ADMIN,
  APP_IDS,
  DAYS_IN_MONTH,
  VAT_RATE,
  VAT_MULTIPLICATOR,
  COMPANY_ACCOUNT_BANK,
  COMPANY_ACCOUNT_NUMBER,
  COMPANY_ACCOUNT_IBAN,
  COMPANY_ACCOUNT_SWIFT,
  PAYMENT,
  ADMIN_COMPANY_SLUG,
  SERVICE_USER_ID,
  INVITATION_APP_IDS,
  GA_USERPORTAL,
  GA_BACKOFFICE,
  HTTP_UNAUTHORIZED_ERROR,
  HTTP_BAD_REQUEST_ERROR,
  HTTP_NOT_ALLOWED_ERROR,
  HTTP_NOT_FOUND_ERROR,
  HTTP_CONFLICT_ERROR,
  HTTP_REQUEST_ABORTED,
  DATE_FORMAT_CZ,
  DATETIME_FORMAT_CZ,
  DATETIME_FORMAT_FULL_CZ,
  DATE_FORMAT_EN,
  DATETIME_FORMAT_EN,
  DATETIME_FORMAT_FULL_EN,
  DATEPICKER_DATE_FORMAT_CZ,
  DATEPICKER_DATE_FORMAT_EN,
  PRE_REGISTERED_USER_PASSWORD_HASH,
  SALARY_RANGE_MAX_DIFF,
  ATTACHMENT_MAX_SIZE_MB,
  ATTACHMENT_MAX_SIZE,
  ATTACHMENT_TYPES,
  ATTACHMENT_TYPE,
  LINK_TYPES,
  LINK_TYPE,
  LINKEDIN_URL_PREFIX,
  LINKEDIN_URL_MASK,
  COMPANY_LOGO_POSITION,
  COMPANY_LOGO_POSITIONS,
  CONTENT_MODULE_TYPE,
  CONTENT_MODULE_TYPES,
  PEOPLE_MODULE_PHOTO_STYLE,
  PEOPLE_MODULE_PHOTO_STYLES,
  PEOPLE_MODULE_DISPLAY,
  PEOPLE_MODULE_DISPLAYS,
  PEOPLE_MODULE_CONTACT,
  PEOPLE_MODULE_CONTACTS,
  GALLERY_MODULE_DISPLAY,
  GALLERY_MODULE_DISPLAYS,
  OAUTH,
  SUBSCRIPTION_WARNING_DAYS_FROM,
  SUBSCRIPTION_WARNING_DAYS,
  SUBSCRIPTION_EXTRA_DAYS,
  SUBSCRIPTION_PLAN_ID_FREE,
  SUBSCRIPTION_PLAN_ID_TRIAL,
  SUBSCRIPTION_PLAN_ID_STANDARD_LEAD,
  SUBSCRIPTION_PLAN_ID_STANDARD_FIX,
  SUBSCRIPTION_PLAN_ID_RECRUITMENT,
  SUBSCRIPTION_PLAN_ID_PREMIUM,
  SUBSCRIPTION_LENGTH_BETA_MONTHS,
  SUBSCRIPTION_LENGTH_TRIAL_MONTHS,
  SUBSCRIPTION_DEFAULT_LEAD_PRICE,
  isLeadPlan,
  isHirePlan,
  LEAD_TYPE,
  LEAD_REVIEW_REASONS,
  LEAD_QUALITY,
  LEAD_QUALITY_OPTIONS,
  LEAD_QUALITY_SETUP,
  B2B_LEVEL,
  SUBSCRIPTION_PLAN_FEATURES,
  FOLLOW_UP_LIMITS,
  JOB_APPLICATION_REJECTION_MODE,
  REJECTION_NOTES_MAX_LENGTH,
  CANDIDATE_OFFER_MESSAGE_MODE,
  OFFER_NOTES_MAX_LENGTH,
  JOB_APPLICATION_CHANGE_TYPE,
  OUTREACH_CHANNEL,
  JOB_OFFER_CHANGE_TYPE,
  AI_RECRUITER,
  AI_RECRUITER_TRIGGER,
  AI_RECRUITER_ITEM_STATUS,
  AI_RECRUITER_REASON,
  AI_RECRUITER_ANSWERED,
  AI_RECRUITER_RUN_STATUS,
  subscriptionWillExpireSoon,
  LEVELS,
  LANGUAGE,
  LANGUAGES,
  I18N_LANGUAGES,
  DATA_LANGUAGES,
  DEFAULT_LANGUAGE_ID,
  DEFAULT_LANGUAGE_CODE,
  DEFAULT_DATA_LANGUAGE_CODE,
  LANGUAGE_LEVELS,
  LANGUAGE_NAME,
  EDUCATION,
  EDUCATIONS,
  EDUCATION_TITLE,
  EDUCATIONS_ISCED_SORTED,
  EDU_LEVELS_IMPORT_MAP,
  getImportedEduLevel,
  EMPLOYMENT,
  EMPLOYMENTS,
  RATE_VALIDATED_EMPLOYMENTS,
  DEFAULT_RATE_PERIOD,
  RATE_PERIOD,
  HOURLY_RATE_MIN,
  DAILY_RATE_MIN,
  MONTHLY_RATE_MIN,
  YEARLY_RATE_MIN,
  DEFAULT_ALLOCATION_PERIOD,
  ALLOCATION_PERIOD,
  CURRENCY,
  HOMEOFFICE_MIN_VALUE,
  HOMEOFFICE_MAX_VALUE,
  DEFAULT_CURRENCY,
  CURRENCIES,
  ORDER_CURRENCIES,
  getSliderStepByCurrency,
  getSliderMinByCurrency,
  getSliderMaxByCurrency,
  ANONYMIZATION,
  PART_TIME_EMPLOYMENT,
  PART_TIME_CONTRACT,
  JOB_APPLICATION_STATUS,
  JOB_APPLICATION_STATUSES_BACKOFFICE,
  JOB_APPLICATION_STATUS_NOTIFICATIONS,
  isJobApplicationInactive,
  JOB_APPLICATION_TYPE,
  JOB_OFFER_STATUS,
  activeJoStatusIds,
  inactiveJoStatusIds,
  isJobOfferInactive,
  isJobOfferCancelable,
  DAYS,
  MONTHS,
  YEARS,
  COMPANY_SIZE,
  COMPANY_SIZES,
  COMPANY_DESCRIPTION_MAX_LENGTH,
  COMPANY_TYPE,
  SUITABLE_FOR,
  SEO_TYPES,
  TRANSLATED_TYPES,
  getTranslatedTypePath,
  MATCH,
  SUBSCRIPTION_ORDER_STATUS,
  SUBSCRIPTION_ORDER_BILLING_PERIOD,
  LOOKING_FOR_JOB,
  CANDIDATE_TYPE,
  CANDIDATE_TYPES,
  CANDIDATES_MIN_SCORE_DEFAULT,
  CANDIDATES_MIN_SCORE,
  NEW_JOB_NOTIFICATION_MIN_SCORE,
  CANDIDATE_SEARCH_MIN_SCORE,
  CANDIDATE_SEARCH_MIN_SKILLS,
  EXCLUSIVE_SEARCH_ITEM_KEYS,
  MAIL,
  COMPANY_NOTIFICATIONS,
  USER_MAIL_PREFIX_KEY,
  USER_MAIL_PREFIX_KEYS,
  isOptionalMail,
  JOB_REACTIVATED_AS_NEW_DAYS,
  SEARCH_MODE_SCORING,
  SEARCH_MODE_STRICT,
  PLACES_API_PLACE_TYPE,
  PLACES_API_COUNTRY_ID,
  SUGGESTED_SKILLS_COUNT,
  JOB_MIN_SKILLS_COUNT,
  JOB_MIN_SKILLS_COUNT_MANAGED,
  getJobMinSkillsCount,
  JOB_MIN_HARD_SKILLS_COUNT,
  NOT_SPECIFIED_SLUG,
  NEW_CANDIDATES_TYPE,
  ROLE,
  PROFILE_PARSER,
  USER_IMPORT_SOURCE,
  USER_IMPORT_JOB_STATUS,
  USER_IMPORT_ITEM_STATUS,
  USER_IMPORT_MAX_FILES,
  USER_IMPORT_MIME_TYPES,
  USER_PROFILE_TYPE,
  ALL_JOBS_KEY,
  ALL_JOBS_LINK,
  TOP_COMPANIES,
  JOB_APPLICATION_EXPORT_COMPANY,
  JOB_APPLICATION_EXPORT_COMPANIES,
  JOB_APPLICATION_EXPORT_AGREEMENT,
  ATS,
  ATS_ALL,
  ATS_PUBLIC,
  JUNIOR_MONTHS_MAX,
  SENIOR_MONTHS_MIN,
  getSkillLevelByExperience,
  OLD_SLUG_REDIRECTION,
  containsOldSlug
};
